module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00579.2da1a47c.jpg";